// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/get_experiment_data_request.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "../../../../google/protobuf/field_mask_pb";
import { file_google_protobuf_field_mask } from "../../../../google/protobuf/field_mask_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/get_experiment_data_request.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_data_request: GenFile = /*@__PURE__*/
  fileDesc("CklxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZ2V0X2V4cGVyaW1lbnRfZGF0YV9yZXF1ZXN0LnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEiiAEKGEdldEV4cGVyaW1lbnREYXRhUmVxdWVzdBIaCg1leHBlcmltZW50X2lkGAEgASgJSACIAQESMQoIZ2V0X21hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrSAGIAQFCEAoOX2V4cGVyaW1lbnRfaWRCCwoJX2dldF9tYXNrYgZwcm90bzM", [file_google_protobuf_field_mask]);

/**
 * Rpc request to retrieve Experiment data
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.GetExperimentDataRequest
 */
export type GetExperimentDataRequest = Message<"quanterix.simoa_one.analysis_app_api.v1.GetExperimentDataRequest"> & {
  /**
   * Unique id (UUID) of the requested experiment
   *
   * @generated from field: optional string experiment_id = 1;
   */
  experimentId?: string;

  /**
   * Represents a set of field paths to be returned in the get request. If
   * omitted, all fields are included in the response
   *
   * See: https://protobuf.dev/reference/protobuf/google.protobuf/#field-mask
   *
   * @generated from field: optional google.protobuf.FieldMask get_mask = 2;
   */
  getMask?: FieldMask;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.GetExperimentDataRequest.
 * Use `create(GetExperimentDataRequestSchema)` to create a new message.
 */
export const GetExperimentDataRequestSchema: GenMessage<GetExperimentDataRequest> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_get_experiment_data_request, 0);

